import {Badge} from "@/components/ui/badge";
import {cva} from "class-variance-authority";
import {useTranslations} from "@/contexts/TranslationContext";

const badgeVariants = cva('ml-2 px-2 py-1 text-2xs uppercase leading-none', {
    variants: {
        variant: {
            local: 'text-gray-medium opacity-50',
            dev: 'bg-destructive text-destructive-foreground',
            stag: 'bg-warning text-secondary-foreground',
            prd: 'bg-secondary text-secondary-foreground'
        },
    },
    defaultVariants: {
        variant: 'local'
    }
})

type BadgeVariant = "local" | "dev" | "stag" | "prd" | null | undefined;

interface EnvBadgeProps {
    env: string;
    showText?: boolean;
    scopeSystem?: {
        label: string;
        value: string;
    }
}

export function EnvBadge({ env, showText = false, scopeSystem }: EnvBadgeProps) {
    const t = useTranslations();

    const isProd = !(env === "local" || env === "dev" || env === "stag");

    return (
       <div className={"flex flex-col"}>
           {!isProd && (
               <div>
                   {showText && ('Umgebung:')}
                   <Badge variant='outline' className={badgeVariants({ variant: env as BadgeVariant })}>
                       {env}
                   </Badge>
               </div>
           )}
           {(scopeSystem && scopeSystem.value === "external") && (
               <div className={"flex gap-1 items-center"}>
                   {t["header.langSelector.scopeSystem.heading"]}:
                   <Badge variant={"outline-invert"}>
                       {t["header.langSelector.scopeSystem.external"]}
                   </Badge>
               </div>
           )}
       </div>
    );
}